import axios from "axios";
import database from './db';
import DatabaseWorker from '@/database-worker';
import { INTERACTION_FIELDS, PUB_USER_SELECTION } from "../constants/players";

const actions =  {
    async getPlayers(context, ids) {
        // DatabaseWorker.send({
        //     action: 'GET_PLAYERS_INTERACTIONS'
        // });
        let entries;
        if (ids) {
            entries = await database.players.where('id').anyOf(ids).toArray();
            let not_found = ids.filter(id => !entries.map(entry => entry.id).includes(id));
            // context.dispatch('fetchPlayers', not_found);
        } else {
            entries = await database.players.orderBy('id').toArray();

        }
        context.commit('addPlayers', entries);
    },

    async fetchMissingPlayers(context, ids = null) {
        context.commit('setFetchingPlayers', true);
        let players_to_fetch = [];
        let existing_player_ids = await database.players.orderBy('id').toArray();
        existing_player_ids =  existing_player_ids.map(player => player.id);
        let retrieved_players = [];
        if (!ids) {
            let all_logs = await database.log_entries.orderBy('timestamp').reverse().toArray();
            all_logs.forEach(log => {
                let data = log?.data || {};
                let data_keys = Object.keys(data);
                data_keys.forEach(key => {
                    if (INTERACTION_FIELDS.includes(key)) {
                        if ( 
                            players_to_fetch.indexOf(data[key]) === -1 
                            && existing_player_ids.indexOf(data[key]) === -1
                        ) {
                            players_to_fetch.push(data[key]);
                        }
                    }
                })
            });
            players_to_fetch = players_to_fetch.sort().filter(id => ! ["N/A", -1, 0].includes(id));
        } else {
            players_to_fetch = ids.filter(id => !existing_player_ids.includes(id));
        }
        let num_players = players_to_fetch.length;
        let cur_index = 1;
        for (let player_id of players_to_fetch.sort()) {
            let response = await axios.get(`https://api.torn.com/user/${player_id}?selections=${PUB_USER_SELECTION.replaceAll(' ', '')}&key=${context.state.auth.key}`);
            let new_player = {
                id: player_id,
                ...response.data
            };
            console.log(`Adding Player: ${cur_index}/${num_players}`, new_player);
            // retrieved_players.push(new_player);
            await database.players.put(new_player);
            await sleep(610);
            cur_index +=1;

        }
        context.commit('setFetchingPlayers', false);
        // context.dispatch('getPlayers');

    },


    async calculatePlayerStats(context) {
        context.commit('setCalculatingInteractions', true);
        DatabaseWorker.send({
            action: 'GET_PLAYERS_INTERACTIONS'
        });
    },

    async fetchPlayers(context, ids=null) {
        let players = await database.players.toArray();
        players = players.map(player => player.id);
        if (ids === null) {
            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }
            let all_ids = context.getters.logs.map(log  => {
                let data = log.data;
                return data.attacker || data.defender || data.buster || data.user || data.player || data.sender || data.receiver || data.recipient || data.seller || data.buyer || data.author;
            }).filter(id => id && id > 0 );
             
            ids =all_ids.filter((id, index, self) => id && !players.includes(id) && onlyUnique(id, index, self));

        }
        // console.log("players_to_fetch", ids);
        // console.log("existing players", players);
        for (let player_id of ids.sort()) {
            let response = await axios.get(`https://api.torn.com/user/${player_id}?selections=${PUB_USER_SELECTION.replaceAll(' ', '')}&key=${context.state.auth.key}`);
            if (response.data.error) {
                console.log("Error fetching player", player_id, response);
                await sleep(650);
                continue;
            }
            let new_player = {
                id: player_id,
                ...response.data
            };
            // console.log("adding player: ", new_player);
            await database.players.put(new_player);
            context.commit('addPlayers', [new_player]);
            await sleep(650);

        }
    },
   
};

const mutations = {
    // Take array, sets as ID-indexed object.
    addPlayers(state, value) {
        value.reduce((players, player) => {
            players[player.id] = player;
            return players;
        }, state.players);
    },


    setFetchingPlayers(state, value) {
        state.sync.fetching_players = value;
    },
}

export default {
    actions,
    mutations
};